import {useState} from 'react' 
import {briefcaseIcon, phoneIcon, computerIcon} from '@/lib/icons.js'
export default function CollapsibleAgentTile({agent})

{
   let no_rep_message = agent.no_rep_message ? (<h5>{agent.no_rep_message} </h5>) : ''
   const [addressCollapsed, setAddressCollapsed] = useState(true)

  return (<div className='lexcms-rep-collapsible-tile'> 
         <div className='lexcms-rep-main-info-container' >
           <div className='lexcms-rep-state-icon'>
              {agent.state}
           </div>
           <div className='lexcms-rep-name-container' >
             <h4 onClick={(e) => { setAddressCollapsed(!addressCollapsed )}  }>{agent.name}</h4> 
             { agent.territory_name && <div><i>{agent.territory_name}</i></div> }
             {!addressCollapsed &&

             <div className='lexcms-rep-details'>
               <div className='lexcms-address-area'> 
                  {briefcaseIcon}
                 <div>
                 <p>{agent.address_1} </p> 
                 {agent.address_2 &&
                  <p>{agent.address_2} </p> 
                 }
                 {!agent.is_foreign_address &&
                   <p>{agent.city}, {agent.state} {agent.zip }</p> 
                 }
                 {agent.is_foreign_address  &&
                   <p>{agent.foreign_address}</p>
                 }
                 </div>
               </div>
               <div className='lexcms-phone-area'> 
                  {phoneIcon}
                 <p>{agent.phone_1}</p> 
               </div>
               <div className='lexcms-rep-website-area'> 
                 {computerIcon}
                 <a target='_blank' onClick={(e) => e.stopPropagation() } href={agent.url} >
                 <span  >{agent.url}</span> 
               </a>
               </div>
             </div>

             }
           </div>
           <button className={`lexcms-agent-rep-address-toggle ${!addressCollapsed ? 'active' : '' }`} onClick={() => setAddressCollapsed(!addressCollapsed )  } >
           </button>
        </div>
            {no_rep_message}
      </div>);

}
